export default {"src":"/_next/static/media/filledstar.02543ef9.svg","height":48,"width":48};